export interface Role {
    roleName: string;
    displayName: string;
    institutionId: string | null;
}

// *** Current Roles ***
// 'REEF_ADMINISTRATOR': {roleName: 'admin', institutionId: null},
// 'SUPER_ADMINISTRATOR': {roleName: 'superAdmin', institutionId: null},
// 'SALES_OPS': {roleName: 'salesops', institutionId: null},
// 'INSTITUTION_ADMINISTRATOR': {roleName: 'institutionAdmin', institutionId: null},
// 'ADVANCED_INSTITUTIONAL_ADMINISTRATOR': {roleName: 'institutionAdminAdvanced' },
// 'INTEGRATION_ADMINISTRATOR': {roleName: 'integrationAdmin', institutionId: null},
// 'PARTICIPANT': {roleName: 'participant', institutionId: null},
// 'FACILITATOR': {roleName: 'facilitator', institutionId: null}

// Route access permissions
export const INSTITUTIONS_LINK_ALLOWED = ['superAdmin', 'admin', 'salesops', 'integrationAdmin'];
export const USER_LINK_ALLOWED = ['superAdmin', 'admin', 'institutionAdmin', 'institutionAdminAdvanced'];
export const ACCESS_CODES_LINK_ALLOWED = ['superAdmin', 'salesops'];

// Feature-specific permissions (based on User Roles & Permissions Matrix)
export const INSTITUTION_ADD_EDIT_ALLOWED = ['superAdmin', 'salesops']; // Institutions: Add/Edit Institution

// Role Hierarchy Levels (based on User Roles & Permissions Matrix)
// Lower numbers = higher privilege level
export const ROLE_HIERARCHY: { [roleName: string]: number } = {
  'superAdmin': 1,           // Highest level, unrestricted access
  'salesops': 2,             // Sales-focused administrative access  
  'admin': 3,                // General administrative access
  'integrationAdmin': 4,     // Technical/integration focused
  'institutionAdmin': 5,     // Institution-scoped access
  'institutionAdminAdvanced': 6, // Enhanced institution-scoped access
  'facilitator': 7,          // Course facilitation
  'participant': 8           // Basic participant access
};

// Roles that require institution assignment
export const INSTITUTION_SCOPED_ROLES = [
  'institutionAdmin',
  'institutionAdminAdvanced'
];

// Roles hidden from the Add Role dropdown (deprecated or not yet implemented)
export const HIDDEN_ASSIGNABLE_ROLES = [
  'institutionAdmin',      // Reports access - moved to separate app
  'integrationAdmin'       // Usage data permissions not yet implemented
];

// Permission Group Constants - for easy component reference
export const PERMISSIONS = {
  // Institution Management
  INSTITUTION_SEARCH_VIEW: ['superAdmin', 'admin', 'salesops'],
  INSTITUTION_ADD_EDIT: ['superAdmin', 'salesops'],
  INSTITUTION_SITE_LICENSE: ['superAdmin', 'salesops'], 
  INSTITUTION_SSO_FEDERATION: ['superAdmin'],
  
  // User Management  
  USER_SEARCH_VIEW: ['superAdmin', 'admin', 'institutionAdminAdvanced'],
  USER_PROFILE_VIEW: ['superAdmin', 'admin', 'institutionAdminAdvanced'],
  USER_PROFILE_EDIT: ['superAdmin', 'admin'],
  USER_IMPERSONATE: ['superAdmin', 'admin', 'institutionAdminAdvanced'],
  USER_EXPORT_AUDIT: ['superAdmin', 'admin'],
  USER_MANAGE_CLICKERS: [], // F - Future functionality
  USER_ROLES_PERMISSIONS: ['superAdmin', 'admin'],
  USER_VIEW_SSO_EMAIL: ['superAdmin', 'admin', 'institutionAdminAdvanced'],
  USER_SSO_UNLINK: ['superAdmin'],
  USER_INSTRUCTOR_COURSES: ['superAdmin', 'admin'],
  
  // System Administration
  ACCESS_CODES_GENERATE: ['superAdmin', 'salesops'],
  PRIVATE_BETA_ATTENDANCE: ['superAdmin'],
  GATEWAY_ADMIN: [], // F - Future functionality  
  ICLICKER_LMS_SETUP: [], // F - Future functionality
  INSTRUCTOR_USAGE_DATA_PHASE1: [], // F - Future functionality
  INSTRUCTOR_USAGE_DATA_PHASE2: [] // F - Future functionality
} as const;

// Navigation item interface for side nav
export interface NavigationItem {
  path: string;
  label: string;
  icon?: string;
  requiredRoles: string[];
}

// Available navigation items (for side nav)
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    path: 'institution-search',
    label: 'Institutions',
    icon: 'institution',
    requiredRoles: INSTITUTIONS_LINK_ALLOWED
  },
  {
    path: 'user-search',
    label: 'Users',
    icon: 'user',
    requiredRoles: USER_LINK_ALLOWED
  },
  {
    path: 'access-codes',
    label: 'Access Codes',
    icon: 'key',
    requiredRoles: ACCESS_CODES_LINK_ALLOWED
  }
];
